const buildSelectOptions = (options, t) => {
  if (!options || !options.length) return [];
  const parsedOptions = options.map(({ code, name }) => {
    if (!code) return [name, name];
    return [code, name];
  });
  parsedOptions.unshift(['', t('PLEASE_CHOOSE')]);
  return parsedOptions;
};

export default buildSelectOptions;
